/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_Local_StorageInputs */



/**
* | output |
* | --- |
* | "Local Storage" |
*
* @param {New_Project_Media_Source_Local_StorageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_local_storage = /** @type {((inputs?: New_Project_Media_Source_Local_StorageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_Local_StorageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Stockage local")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lokaler Speicher")
	if (locale === "it") return /** @type {LocalizedString} */ ("Archiviazione locale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Локальное хранилище")
	if (locale === "es") return /** @type {LocalizedString} */ ("Almacenamiento local")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("本地存储")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ローカルストレージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थानीय भंडारण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Armazenamento local")
	return /** @type {LocalizedString} */ ("Local Storage")
});